import { UseGetPostsDetailsProps } from 'src/client/publication/types'
import { AVATAR_SIZE } from 'src/utils/constants'
import { PostsEndpoints, PostsService } from 'src/services/posts'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { COMMUNITY_TYPE } from 'src/pages/CommunityDetails/constants'
import useRequest from '../useRequest'
import { useUser } from '../useUser'
import { REQUEST_CONFIG } from './useGetPostDetails.constants'

const useGetPostsDetails = ({
  id,
  communityType,
  avatarSize = AVATAR_SIZE,
  enabled = true
}: UseGetPostsDetailsProps) => {
  const { authStatus } = useUser()

  const isUnauthenticated = authStatus === AuthStatus.UNAUTHENTICATED

  const url = isUnauthenticated
    ? PostsEndpoints.getPostDetailsPublic(id)
    : PostsEndpoints.getPostDetails(id)

  return useRequest(
    url,
    () => {
      return isUnauthenticated
        ? PostsService.getPostDetailsPublic({ id, avatarSize })
        : PostsService.getPostDetails({ id, avatarSize })
    },
    {
      enabled: isUnauthenticated ? communityType === COMMUNITY_TYPE.PUBLIC && enabled : enabled,
      ...REQUEST_CONFIG
    }
  )
}

export default useGetPostsDetails
